'use strict';

import React from 'react';
import ReactDOM from 'react-dom';

import Dropzone from'dropzone'

const debug = {
    error   : true,
    dev     : false,
    head    : "{DropzoneReact}"
};

export default class DropzoneReact extends React.Component {

    static displayName = "DropzoneComponent";

    static defaultProps = {
        // djsConfig: {},
        eventHandlers: {},
        djsContainer: '#ui-layout-container'
    };

    constructor(props) {
        super(props)

        this.state = {
            files: []
        };
    }


    /**
     * Configuration of Dropzone.js. Defaults are
     * overriden overriden by the 'djsConfig' property
     * For a full list of possible configurations,
     * please consult
     * http://www.dropzonejs.com/#configuration
     */


    /**
     * React 'componentDidMount' method
     * Sets up dropzone.js with the component.
     */
    componentDidMount() {

        if (debug.dev) console.log(debug.head,".didMount");

        const options = this.props.djsConfig

        Dropzone.autoDiscover = false;

        Dropzone.prototype.filesize = function(size) {
            return gd.utils.Convert.fileSize(size,this.options.filesizeBase);
        };

        if (debug.dev) console.log(debug.head," CREATED DROPZONE within container",this.props.djsContainer);

        this.dropzone = new Dropzone(document.querySelector(this.props.djsContainer), options);
        this.setupEvents();
    }

    /**
     * React 'componentWillUnmount'
     * Removes dropzone.js (and all its globals) if the component is being unmounted
     */
    componentWillUnmount() {

        if (debug.dev) console.log(debug.head,".willUnmount");

        if (this.dropzone) {
            var files = this.dropzone.getActiveFiles();
            this.dropzone.removeAllFiles(true);

            if (files.length > 0) {
                // Well, seems like we still have stuff uploading.
                // This is dirty, but let's keep trying to get rid
                // of the dropzone until we're done here.
                this.queueDestroy = true;

                var destroyInterval = window.setInterval(function()  {
                    if (this.queueDestroy = false) {
                        return window.clearInterval(destroyInterval);
                    }

                    if (this.dropzone.getActiveFiles().length === 0) {
                        this.dropzone = this.dropzone.destroy();
                        return window.clearInterval(destroyInterval);
                    }
                }.bind(this), 500);
            } else {
                this.dropzone = this.dropzone.destroy();
            }
        }

    }

    /**
     * React 'componentDidUpdate'
     * If the Dropzone hasn't been created, create it
     */
    componentDidUpdate() {

        if (debug.dev) console.log(debug.head,".didUpdate");

        this.queueDestroy = false;

        if (!this.dropzone) {
            this.dropzone = new Dropzone(ReactDOM.findDOMNode(this), this.props.djsConfig);
        }
    }

    disable = ()=> {
        if (this.dropzone) {
            this.dropzone.disable();

            //dropzone internally calls stopPropagation and preventDefault even when disabled
            //therefore we need to disable this functionality for dropzone not to interfere with
            //drop events in other components
            this.originalListenersEvents = {};
            const events = ['drop'];
            _.map(this.dropzone.listeners, (l,key)=>{
                this.originalListenersEvents[key] = {};

                events.forEach(name => {
                    const original = l.events[name];
                    this.originalListenersEvents[key][name] = original;
                    l.events[name] = (e, ...extraArgs) => {
                        e.stopPropagation = () => {};
                        e.preventDefault = () => {};
                        original(e, ...extraArgs);
                    };
                });
            })
        }
    }

    enable = ()=> {
        if (this.dropzone) {
            this.dropzone.enable();

            //dropzone internally calls stopPropagation and preventDefault even when disabled
            //in disable function original drop handler has been replaced with custom function
            //and now it is reverted to original
            const events = ['drop'];
            _.map(this.dropzone.listeners, (l,key)=>{
                events.forEach(name => {
                    l.events[name] = this.originalListenersEvents[key][name];
                });
            })
        }
    }

    pasteImage = (file) => {
        if (this.dropzone) this.dropzone.addFile(file);
    };

    removeFile = (fileId, file) => {

        if (this.dropzone) {
            const files = this.dropzone.getActiveFiles();

            // console.log("files =", files)

            // this is old but still needed
            let foundFile = _.find(files, f=>f.fileId === fileId);

            // new fileId
            if (!foundFile) foundFile = _.find(files, f=>_.get(f,'attachment.fileId') === fileId);

            if (foundFile) this.dropzone.removeFile(foundFile);
            else if (file) this.dropzone.removeFile(file);
        }
    };

    removeAllFiles = (cancelIfNecessary) => {
        if (this.dropzone) this.dropzone.removeAllFiles(cancelIfNecessary);
    };

    /**
     * Takes event handlers in this.props.eventHandlers
     * and binds them to dropzone.js events
     */
    setupEvents = () => {
        var eventHandlers = this.props.eventHandlers;

        if (!this.dropzone || !eventHandlers) {
            return;
        }

        for (var eventHandler in eventHandlers) {
            if (eventHandlers.hasOwnProperty(eventHandler) && eventHandlers[eventHandler]) {
                // Check if there's an array of event handlers
                if (Object.prototype.toString.call(eventHandlers[eventHandler]) === '[object Array]') {
                    for (var i = 0; i < eventHandlers[eventHandler].length; i = i + 1) {
                        // Check if it's an init handler
                        if (eventHandler === 'init') {
                            eventHandlers[eventHandler][i](this.dropzone);
                        } else {
                            this.dropzone.on(eventHandler, eventHandlers[eventHandler][i]);
                        }
                    }
                } else {
                    if (eventHandler === 'init') {
                        eventHandlers[eventHandler](this.dropzone);
                    } else {
                        this.dropzone.on(eventHandler, eventHandlers[eventHandler]);
                    }
                }
            }
        }

        this.dropzone.on('addedfile', function(file)  {
            if (file) {
                var files = this.state.files;

                if (!files) {
                    files = [];
                }

                files.push(file)

                this.setState({files: files});
            }
        }.bind(this));

        this.dropzone.on('removedfile', function(file)  {
            if (file) {
                var files = this.state.files;

                if (files && files.length > 0) {
                    for (var i = 0; i < files.length; i++) {
                        if (files[i].name === file.name && files[i].size === file.size) {
                            files.splice(i, 1);
                        }
                    }

                    this.setState({files: files});
                }
            }
        }.bind(this));
    };


    render() {

        if (debug.dev) console.count(debug.head+" render");

        const className = Classes('filepicker dropzone', this.props.className)

        return (
            <div className={className}>
                {this.props.children}
            </div>
        )
    }

};